import script from "./GroupAvatarStack.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupAvatarStack.vue?vue&type=script&setup=true&lang=js"

import "./GroupAvatarStack.vue?vue&type=style&index=0&id=1993699b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1993699b"]])

export default __exports__